const getAvailableServices = (markerServices, allServices, language, labelType = '') => {
    labelType = labelType !== '' ? `_${labelType}` : '';

    // Use service list as template because order is important
    let availableServices = allServices.filter(service => {
        return markerServices
            .map(service => service.identifier)
            .includes(service.identifier);
    });

    // Check if service is available and add strikethrough if not available
    let withdrawalServices = [];
    let depositServices = [];
    let otherServices = [];

    availableServices.map(service => {
        const available = markerServices.find(
            x => x.identifier === service.identifier
        ).available;

        const labelKey = `name${labelType}_${language}`;
        const defaultLabelKey = `name_${language}`;

        let label =
            // labelKey in service ? service[labelKey] : service[defaultLabelKey];
            labelKey in service ? `<span class="InfoWindow__Service InfoWindow__Service--${service.identifier.toUpperCase()}">${service[labelKey]}</span>` : `<span>${service[defaultLabelKey]}</span>`;

        if (available === false) {
            label = `<s>${label}</s>`;
        }

        if (service.group_as === 'withdrawal') {
            withdrawalServices.push(label);
        } else if (service.group_as === 'deposit') {
            depositServices.push(label);
        } else {
            otherServices.push(label);
        }
    });

    return {
        withdrawalServices: withdrawalServices,
        depositServices: depositServices,
        otherServices: otherServices
    };
};

export default getAvailableServices;
